import React, { Component } from "react";

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
// import DialogTitle from '@material-ui/core/DialogTitle';

class CustomMessageDialog extends Component {
    render() {
        return (
            <Dialog
                open={this.props.showCustomMessageDialog}
                onClose={() => this.props.handleCustomMessageDialog(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    <div
                        dangerouslySetInnerHTML={{ __html: this.props.customMessage }}
                    />
                </DialogContentText>
                </DialogContent>
                <DialogActions>
                <Button onClick={() => this.props.handleCustomMessageDialog(false)} color="primary">
                    Ok
                </Button>
                </DialogActions>
            </Dialog>
        )};
    }

export { CustomMessageDialog };
